<template>
    <div>
        <ly-dialog v-model="dialogVisible" :title="loadingTitle" width="560px" :before-close="handleClose">
            <el-form :inline="false" :model="formData" :rules="rules" ref="rulesForm" label-position="right" label-width="auto">
                <el-form-item label="会员套餐名称：" prop="name">
                    <el-input type="text" v-model.trim="formData.name" placeholder="请输入会员套餐名称"></el-input>
                </el-form-item>
                <el-form-item label="有效期：" prop="expireday">
                    <div style="display:flex;width:100%;">
                        <el-input v-model="formData.expireday"  placeholder="请输入有效期天数" v-limitPositiveInt></el-input><span style="margin-left:10px;">天</span>
                    </div>
                </el-form-item>
                <el-form-item label="价格：¥" prop="price">
                    <div style="display:flex;width:100%;">
                        <el-input v-model="formData.price"  placeholder="请输入价格" v-limitPositiveNumberFixed2></el-input>
                    </div>
                </el-form-item>
            </el-form>
            <template #footer>
                <el-button @click="handleClose" :loading="loadingSave">取消</el-button>
                <el-button type="primary" @click="submitData" :loading="loadingSave">确定</el-button>
            </template>
        </ly-dialog>
    </div>
</template>

<script>
    import {tcliveShopvipAdd,tcliveShopvipEdit} from "@/api/api";
    import {url} from '@/api/url'
    import LyDialog from "@/components/dialog/dialog";
    import {deepClone} from '@/utils/util'
    export default {
        components: {LyDialog},
        emits: ['refreshData'],
        name: "addModuleShopVip",
        data() {
            return {
                dialogVisible:false,
                loadingSave:false,
                loadingTitle:'',
                formData:{
                    name:'',
                    expireday:'',
                    price:'',
                },
                rules:{
                    name: [
                        {required: true, message: '请输入会员套餐名称',trigger: 'blur'}
                    ],
                    expireday: [
                        {required: true, message: '请输入有效期天数',trigger: 'blur'}
                    ],
                    price: [
                        {required: true, message: '请输入价格',trigger: 'blur'}
                    ]
                }
            }
        },
        methods:{
            handleClose() {
                this.dialogVisible=false
                this.loadingSave=false
                this.formData = {
                    name:'',
                    expireday:'',
                    price:'',
                }
            },
            addModuleFn(item,flag) {
                this.loadingTitle=flag
                this.dialogVisible=true
                if(item){
                    this.formData=deepClone(item)
                }
            },
            submitData() {
                this.$refs['rulesForm'].validate(obj=>{
                    if(obj) {
                        this.loadingSave=true
                        let param = {
                            ...this.formData
                        }
                        if(this.formData.id){
                            tcliveShopvipEdit(param).then(res=>{
                                this.loadingSave=false
                                if(res.code ==2000) {
                                    this.$message.success(res.msg)
                                    this.handleClose()
                                    this.$emit('refreshData')
                                } else {
                                    this.$message.warning(res.msg)
                                }
                            })
                        }else{
                            tcliveShopvipAdd(param).then(res=>{
                                this.loadingSave=false
                                if(res.code ==2000) {
                                    this.$message.success(res.msg)
                                    this.handleClose()
                                    this.$emit('refreshData')
                                } else {
                                    this.$message.warning(res.msg)
                                }
                            })
                        }

                    }
                })
            },
        }
    }
</script>
<style scoped>

</style>

